"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _NavbarSignout = _interopRequireDefault(require("../elements/NavbarSignout"));

var _NavbarUsernameDropdown = _interopRequireDefault(require("../elements/NavbarUsernameDropdown"));

var _Navigation = _interopRequireDefault(require("../elements/Navigation"));

var _NavigationLink = _interopRequireDefault(require("../elements/NavigationLink"));

var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));

var _NavbarDropdown = _interopRequireDefault(require("../elements/NavbarDropdown"));

var _NavigationDropdownLink = _interopRequireDefault(require("../elements/NavigationDropdownLink"));

var _NavBar = _interopRequireDefault(require("../elements/NavBar"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BestLink = _interopRequireDefault(require("../../elements/links/BestLink"));

var _DropdownItem = _interopRequireDefault(require("../../elements/DropdownItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var NavBarHolder = _styledComponents["default"].div.attrs({
  id: "navbarSupportedContent"
}).withConfig({
  displayName: "HorizontalNavigationFromConfig__NavBarHolder",
  componentId: "sc-1qv4oo8-0"
})(["@media (max-width:767px){height:", ";margin-left:-1rem;margin-right:-1rem;overflow:scroll;}@media (min-width:768px){margin-top:-1rem;margin-bottom:-1rem;height:60px;}"], function (props) {
  return props.displayEnvIndicator ? "calc(100vh - 60px)" : "calc(100vh - 78px)";
});

var Navbar = _styledComponents["default"].ul.attrs({
  className: "navbar-nav mr-auto"
}).withConfig({
  displayName: "HorizontalNavigationFromConfig__Navbar",
  componentId: "sc-1qv4oo8-1"
})(["height:60px;"]);

var NavbarSignoutLink = (0, _styledComponents["default"])(_BestLink["default"]).withConfig({
  displayName: "HorizontalNavigationFromConfig__NavbarSignoutLink",
  componentId: "sc-1qv4oo8-2"
})(["display:block;z-index:1051 !important;padding:0.25rem 1.5rem;&&&{text-decoration:none;}"]);
var NavbarSignoutItem = (0, _styledComponents["default"])(_DropdownItem["default"]).withConfig({
  displayName: "HorizontalNavigationFromConfig__NavbarSignoutItem",
  componentId: "sc-1qv4oo8-3"
})(["z-index:1051 !important;"]);
/**
 * A horizontal navigation based on the navigation configuration
 */

var HorizontalNavigationFromConfig = function HorizontalNavigationFromConfig(_ref) {
  var _ref$config = _ref.config,
      displayEnvIndicator = _ref$config.displayEnvIndicator,
      loggedIn = _ref$config.loggedIn,
      username = _ref$config.username,
      usernameDropdownLinks = _ref$config.usernameDropdownLinks,
      navigationLinks = _ref$config.navigationLinks,
      logo = _ref$config.logo,
      logoText = _ref$config.logoText,
      builds = _ref$config.builds,
      tabletSupport = _ref$config.tabletSupport,
      env = _ref$config.env,
      pathname = _ref.location.pathname;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      mobileNavOpen = _useState2[0],
      setMobileNavOpen = _useState2[1];

  var toggleMobileNav = function toggleMobileNav() {
    setMobileNavOpen(!mobileNavOpen);
  };

  var checkForActive = function checkForActive(to) {
    return pathname === to;
  };

  return _react["default"].createElement(_NavBar["default"], {
    displayEnvIndicator: displayEnvIndicator,
    env: env
  }, _react["default"].createElement(_NavbarSignout["default"], {
    loggedIn: loggedIn,
    env: env
  }, _react["default"].createElement(_NavbarUsernameDropdown["default"], {
    username: username
  }, _react["default"].createElement("div", null, usernameDropdownLinks && usernameDropdownLinks.map(function (_ref2) {
    var name = _ref2.name,
        to = _ref2.to,
        onClick = _ref2.onClick,
        _ref2$visible = _ref2.visible,
        visible = _ref2$visible === void 0 ? true : _ref2$visible;
    return visible && to && to.length ? _react["default"].createElement(NavbarSignoutLink, {
      to: to,
      onClick: onClick,
      key: name
    }, name) : _react["default"].createElement(NavbarSignoutItem, {
      onClick: onClick,
      key: name
    }, name);
  })))), _react["default"].createElement(_Navigation["default"], {
    logo: logo,
    logoText: logoText,
    builds: builds,
    loggedIn: loggedIn,
    tabletSupport: tabletSupport,
    displayEnvIndicator: displayEnvIndicator,
    mobileNavOpen: mobileNavOpen,
    toggleMobileNav: setMobileNavOpen
  }, _react["default"].createElement(NavBarHolder, {
    displayEnvIndicator: displayEnvIndicator,
    className: "collapse navbar-collapse ".concat(mobileNavOpen ? "show" : "hide")
  }, _react["default"].createElement(Navbar, null, navigationLinks && navigationLinks.map(function (_ref3) {
    var name = _ref3.name,
        to = _ref3.to,
        onClick = _ref3.onClick,
        active = _ref3.active,
        _ref3$visible = _ref3.visible,
        visible = _ref3$visible === void 0 ? true : _ref3$visible,
        subLinks = _ref3.subLinks;
    return visible && (subLinks && subLinks.length ? _react["default"].createElement(_NavbarDropdown["default"], {
      title: name,
      isActive: active,
      key: "nav-link-".concat(name)
    }, subLinks.map(function (sublink) {
      return _react["default"].createElement(_NavigationDropdownLink["default"], {
        key: sublink.name,
        to: sublink.to,
        name: sublink.name,
        isActive: checkForActive(sublink.to),
        toggleMobileNav: toggleMobileNav
      });
    })) : _react["default"].createElement(_NavigationLink["default"], {
      key: "nav-link-".concat(name),
      to: to,
      name: name,
      onClick: onClick,
      isActive: checkForActive(to),
      mobileNavOpen: mobileNavOpen,
      toggleMobileNav: toggleMobileNav
    }));
  }), _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(_NavbarDropdown["default"], {
    title: username
  }, usernameDropdownLinks && usernameDropdownLinks.map(function (_ref4) {
    var name = _ref4.name,
        to = _ref4.to,
        onClick = _ref4.onClick,
        _ref4$visible = _ref4.visible,
        visible = _ref4$visible === void 0 ? true : _ref4$visible;
    return visible && _react["default"].createElement(_NavigationDropdownLink["default"], {
      key: name,
      to: to,
      name: name,
      isActive: checkForActive(to),
      mobileNavOpen: mobileNavOpen,
      toggleMobileNav: toggleMobileNav,
      onClick: onClick
    });
  })))))));
};

var DropDownShape = {
  name: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  visible: _propTypes["default"].bool
};
HorizontalNavigationFromConfig.propTypes = {
  config: _propTypes["default"].shape({
    env: _propTypes["default"].string.isRequired,
    loggedIn: _propTypes["default"].bool.isRequired,
    username: _propTypes["default"].string.isRequired,
    displayEnvIndicator: _propTypes["default"].bool.isRequired,
    usernameDropdownLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape)),
    navigationLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape)),
    logo: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    logoText: _propTypes["default"].string,
    builds: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      build: _propTypes["default"].string.isRequired
    })),
    tabletSupport: _propTypes["default"].bool
  }).isRequired,
  location: _propTypes["default"].shape({
    pathname: _propTypes["default"].string.isRequired
  }).isRequired
};

var _default = (0, _reactRouter.withRouter)(HorizontalNavigationFromConfig);

exports["default"] = _default;